import { gql } from "@apollo/client";

export const AddItemLdgrAssociByLdgr = gql`
  mutation AddItemLdgrAssociByLdgr(
    $token: String!
    $customer_id: ID!
    $user_details: SubscribedUser!
    $itemIds: [ID!]!
    $ldgrId: ID!
  ) {
    AddItemLdgrAssociByLdgr(
      token: $token
      customer_id: $customer_id
      user_details: $user_details
      itemIds: $itemIds
      ldgrId: $ldgrId
    )
  }
`;

export const UpdateItemLdgrAssociByLdgr = gql`
  mutation UpdateItemLdgrAssociByLdgr(
    $token: String!
    $customer_id: ID!
    $itemIds: [ID!]!
    $ldgrId: ID!
    $user_details: SubscribedUser!
  ) {
    UpdateItemLdgrAssociByLdgr(
      token: $token
      customer_id: $customer_id
      itemIds: $itemIds
      ldgrId: $ldgrId
      user_details: $user_details
    )
  }
`;

export const DeleteItemLdgrAssociByLdgr = gql`
  mutation DeleteItemLdgrAssociByLdgr(
    $token: String!
    $customer_id: ID!
    $itemIds: [ID!]!
    $ldgrId: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteItemLdgrAssociByLdgr(
      token: $token
      customer_id: $customer_id
      itemIds: $itemIds
      ldgrId: $ldgrId
      user_details: $user_details
    )
  }
`;
